import Loading from './loading.vue'
import Vue from 'vue';

const LoadingDiv= Vue.extend(Loading);
let instance;
/**
 * 打开loading对话框
 * @param  {[type]} option {text:'内容',background:'rgba(xx,xx,xx,xx)',color:'',borderWidth:10,duration:1,widht:50,height:50}
 * 使用方式为：Loading.show({text:'正在加载...'})
 * @return {[type]}        [description]
 */
const show = function(option) {
    if (!instance) {
      instance = new LoadingDiv({
        el: document.createElement('div')
      });
    }
    instance.text = option.text;
    let borderColor = option.color || '#f5cd79';
    instance.loaderStyle = {
      background : option.background||  'rgba(0,0,0,.5)'
    }
    instance.ballStyle = {
        borderColor: borderColor + ' ' + borderColor + ' ' + borderColor + ' ' + 'transparent',
        borderWidth: (option.borderWidth||10) + 'px',
        borderStyle: 'solid',
        animationDuration: (option.duration||1) + 's',
        width: (option.width || 50) +'px',
        height: (option.height || 50)  + 'px'
    };
    if (instance.visible) return;
    document.body.appendChild(instance.$el);
    Vue.nextTick(() => {
      instance.visible = true;
    });
};

/**
 * 关闭网络加载hint提示
 * @return {[type]} [description]
 */
const hide = function() {
   if (instance) {
     instance.visible = false;
   }
}

export default{
	show,
	hide
}



// WEBPACK FOOTER //
// ./src/components/loading/index.js